export default "__VITE_ASSET__CnXeyyck__"